* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

.loading-header,
.header {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 9);
  width: 100%;

  gz-widget-header-item {
    flex: 1;
  }

  .vertical-bar {
    background-color: var(--chart-101-pressed-dividers);
    width: 1px;
    height: 100%;
    margin: calc(var(--spacer) * 1.5);
  }
}

.header {
  padding: var(--spacer) 0;
}

gz-basic-table::part(column-1) {
  justify-content: center;
}
